import { ConnectedIntegrationsViewProps } from './types';
import ButtonWithPopupWrapper from './ButtonWithPopupWrapper';
import CogIcon from '../icons/Cog';
import styled from '@emotion/styled';
import { ActionButton, colors, Text } from '@innovationdepartment/proxima-ui';
import AddIcon from '../icons/Add';
import { BrandIntegrationStatus } from 'constants/integrations';

const IntegrationListWrapper = styled.div`
  margin-bottom: 8px;
  width: min(100vw, 440px);
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 24px;
`;

const IntegrationWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  border-top: 1px solid ${colors.neutral20};
`;

const IntegrationLeftContentWrapper = styled.div`
  flex: 1;
  display: flex;
  gap: 8px;
  align-items: center;
`;

const ConnectedIntegrationsView = (props: ConnectedIntegrationsViewProps) => {
  const { integrations } = props;
  const getVariant = (status: BrandIntegrationStatus) => {
    switch (status) {
      case BrandIntegrationStatus.Connected:
        return 'success';
      case BrandIntegrationStatus.Incomplete:
      case BrandIntegrationStatus.TermsRequired:
        return 'incomplete';
      case BrandIntegrationStatus.Disconnected:
        return 'error';
      default:
        return 'default';
    }
  };

  const getLabel = (status: BrandIntegrationStatus) => {
    switch (status) {
      case BrandIntegrationStatus.Connected:
        return 'Connected';
      case BrandIntegrationStatus.Incomplete:
        return 'Incomplete';
      case BrandIntegrationStatus.TermsRequired:
        return 'Terms Required';
      case BrandIntegrationStatus.Disconnected:
        return 'Reconnect';
      default:
        return 'Connect';
    }
  };

  return (
    <ButtonWithPopupWrapper buttonIcon={<CogIcon />} buttonText="Integrations" flexibleWidth>
      <IntegrationListWrapper>
        <TitleWrapper>
          <Text variant="body1">Integrations</Text>
          <Text variant="body2">Connect your data sources for better results</Text>
        </TitleWrapper>
        {integrations.map((integrationState) => {
          const { icon, name, onConnect, type, isConnected } = integrationState;
          return (
            <IntegrationWrapper key={name}>
              <IntegrationLeftContentWrapper>
                {icon}
                <Text variant="tag1Semibold">{name}</Text>
              </IntegrationLeftContentWrapper>
              <ActionButton
                icon={isConnected ? undefined : <AddIcon />}
                label={isConnected ? 'Connected' : getLabel(integrationState.status)}
                variant={isConnected ? 'success' : getVariant(integrationState.status)}
                onClick={() => onConnect(type)}
              />
            </IntegrationWrapper>
          );
        })}
      </IntegrationListWrapper>
    </ButtonWithPopupWrapper>
  );
};

export default ConnectedIntegrationsView;
